import { Settings } from 'luxon'
import lang from '@/services/lang'
import Config from '@/config/app'

export default {
  methods: {
    setDefaultLanguage () {
      const selectedLanguage = this.$cookies.get(Config.COOKIES.LANGUAGE_KEY)
      if (!selectedLanguage) {
        // For new users without saved language preference, use browser detection
        return this.updateBrowserLanguage()
      }
      // Use saved language preference
      return this.setLocaleLang(selectedLanguage.value)
    },

    updateBrowserLanguage () {
      const browserLanguage = window.navigator.language
      const detectedLanguage = browserLanguage === 'ja' || browserLanguage.startsWith('ja-') ? 'ja' : 'en'
      
      // Set browser language cookie for tracking
      const tempLang = this.$cookies.get('browser-language')
      if (!tempLang || (tempLang !== detectedLanguage)) {
        lang.setBrowserLanguage(detectedLanguage)
      }
      
      this.setLocaleLang(detectedLanguage)
    },

    setLocaleLang (language) {
      this.$i18n.locale = language
      this.$vuetify.lang.current = language
      Settings.defaultLocale = language
    }
  },

  created () {
    this.setDefaultLanguage()
  }
}
